import { render, staticRenderFns } from "./FormatListBulleted.vue?vue&type=template&id=2b799082&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FormatListBulleted.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/icons/FormatListBulleted.vue
// module id = 2409
// module chunks = 1